import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { App } from "./containers/App";
import store from "./store";
import { defaultTheme } from "./theme/material";
import smoothscroll from "smoothscroll-polyfill";
import "./index.css";
import { MuiThemeProvider } from "@material-ui/core";

// kick off the polyfill for smooth scrolling!
smoothscroll.polyfill();

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={defaultTheme}>
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById("root") as HTMLElement,
);
